import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps} from 'react-router-dom';
import {Layout, Card} from 'antd';
import {FormattedMessage} from "react-intl";
import LoginForm from "@components/auth/LoginForm";
import {loginRequest} from '@actions/auth';
import {getRedirectPath} from "../App";

const {Content} = Layout;

interface PropsFromDispatch {
  loginRequest: typeof loginRequest;
}

type AllProps = RouteComponentProps<{}>

class LoginPage extends React.Component<AllProps> {

  redirect = () => {
    // this.props.history.push(getRedirectPath());
    window.location.replace(window.location.origin + "#" + getRedirectPath())
    // window.location.href = window.location.origin
  };
  redirectToResetPasswordPage = () => {
    this.props.history.push('/reset_password');
  };

  public render() {
    return (
      <Layout>
        <Content>
          <Card className={'login-form-wrapper'}>
            <LoginForm login={this.props.loginRequest} onLoginSuccess={this.redirect}/>
            <a className="forgot-pass" href="#" onClick={this.redirectToResetPasswordPage}>
              <FormattedMessage id="app.forgot_password" defaultMessage={'Forgot Password'}/>
            </a>
          </Card>
        </Content>
        <p style={{textAlign:'center' , color:'#000000'}}>ورژن: V 0.11.01 </p>
      </Layout>
    )
  }
}


const mapDispatchToProps = {
  loginRequest,
};


export default connect(null, mapDispatchToProps)(LoginPage);


